<!-- NEWDESIGN DONE -->
<div class="fixed z-above right-safeIntercom bottom-safeBottom p-4">
  <div
    class="relative rounded max-w-64 bg-v2-rose-600 text-v2-white text-center font-bold p-4 grid grid-cols-1 gap-4 text-sm"
  >
    <ng-content></ng-content>
    <app-button color="white/red" [fullWidth]="true" (click)="stop.emit()">{{
      buttonLabel
    }}</app-button>
  </div>
</div>
